import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import { ConfigService } from 'app/services/config.service';
import { GridService } from 'app/services/grid.service';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader
{
    private _httpClient = inject(HttpClient);
    private configService = inject(ConfigService);

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation>
    {
        return this.configService.getLanguageTranslations(lang).pipe(
            switchMap((result) => {
                if (result.data && result.data.length){
                    //console.log('translations', result.data[0].JsonTraduzioni);
                    return of<Translation>(result.data[0].JsonTraduzioni);
                }
                return of<Translation>({});
            }));
        //return this._httpClient.get<Translation>(`./assets/i18n/${lang}.json`);
    }
}

